import {Entity} from '../base/entity';

export class ItemItemType extends Entity {

  public static readonly TABLENAME = 'item_item_type';

  public static readonly ITEM_ID = 'item_id';
  public static readonly ITEM_TYPE_ID = 'item_type_id';

  itemId: string;
  itemTypeId: number;
  itemName: string;
}
